import { gql } from 'graphql-request';

export const FRAGMENT_MSA_CORE = gql`
  fragment MsaCore on MsaDetails {
    msa
    name
    zipCount
  }
`;
